export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  comId: number;
  comName: string;
  comCode: string;
  comCreatedById: number;
  comStatus: number;
  comCreatedByDate: string;
};

export type MasterDataType = {
  id: number;
  clinicId: number;
  code: string;
  createdByDate: string;
  createdById: number;
  name: string;
  status: number;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  code: string;
  name: string;
  status: number;
};

export const initialFormData: MasterFormDataType = {
  code: "",
  name: "",
  status: 1,
};
